var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEditSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1532 3.2051C11.2889 3.04466 11.4566 2.91407 11.6458 2.82164C11.835 2.72922 12.0415 2.67699 12.2521 2.66829C12.4627 2.65959 12.6729 2.69461 12.8691 2.77111C13.0654 2.84761 13.2434 2.96392 13.392 3.11262C13.5405 3.26132 13.6562 3.43915 13.7318 3.63478C13.8074 3.83041 13.8411 4.03955 13.8309 4.24886C13.8207 4.45817 13.7667 4.66307 13.6724 4.85049C13.5781 5.03791 13.4455 5.20375 13.2832 5.33743L6.09467 12.534L3.16602 13.3337L3.96474 10.4017L11.1532 3.2051Z",
    stroke: "#0076E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.166 4.33301L12.166 6.33301",
    stroke: "#0076E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditSmall);
export default __webpack_public_path__ + "static/media/Icon-edit-small.a04064d9d940df5c344580ed66e5e42d.svg";
export { ForwardRef as ReactComponent };